// Auto-gap: keys used in code but missing from zh-CN
export default {
  'pages.admin.providerCard.badge.commercialLicense': '商業授權',
  'pages.admin.providerCard.badge.sort': '序號 {n}',
  'pages.admin.providerCard.config.commercialLicense': '商業授權',
  'pages.admin.providerCard.config.funasrAddr': 'funasr uri',
  'pages.admin.providerCard.config.no': '否',
  'pages.admin.providerCard.config.yes': '是',
  'pages.admin.user.supplierCode': '授權編碼',
  'pages.admin.user.supplierCode.label': '授權編碼',
  'pages.admin.user.supplierCode.tooltip': '填寫企業授權編碼，非空即為該企業的管理賬號；留空解除繫結',
  'pages.agents.delete.confirm.all': '確認刪除該說話人及其所有樣本?',
  'pages.agentSetting.asr.label': '語音識別模型',
  'pages.agentSetting.asr.placeholder': '選擇語音識別（ASR）提供方',
  'pages.agentSetting.asr.required': '請選擇 ASR 提供方',
  'pages.agentSetting.asr.tip': '與系統管理中已配置的 ASR 提供方一致；影響裝置端語音識別管線。',
  'pages.agentSetting.asr.title': 'ASR · 語音識別',
  'pages.agentSetting.memory.clear.error': '記憶清除失敗',
  'pages.agentSetting.memory.clear.success': '記憶已清除',
  'pages.agentSetting.memory.edit.error': '記憶更新失敗',
  'pages.agentSetting.recognitionSpeed.fast': '快速',
  'pages.agentSetting.recognitionSpeed.normal': '正常',
  'pages.agentSetting.recognitionSpeed.slow': '耐心',
  'pages.agentSetting.tts.label': '語音合成模型',
  'pages.agentSetting.tts.title': 'TTS · 語音合成',
  'pages.common.confirm': '確定',
  'pages.devices.bridge.connectorOffline': '已繫結；電腦執行 SaiboAssistant 輸入下方配對碼即可',
  'pages.devices.bridge.copyPairCode': '複製配對碼',
  'pages.devices.bridge.notConfigured': '裝置未繫結或未關聯智慧體',
  'pages.devices.bridge.pairCode': '配對碼',
  'pages.devices.bridge.ready': '已繫結智慧體，Connector 線上',
  'pages.devices.bridge.runtime': '龍蝦對話（裝置端選擇後自動檢測）',
  'pages.devices.copy.iccidEmpty': 'ICCID 為空，無法複製',
  'pages.devices.copy.iccidSuccess': 'ICCID 已複製',
  'pages.devices.copy.macEmpty': 'MAC 地址為空，無法複製',
  'pages.devices.copy.pairCodeEmpty': '配對碼為空，無法複製',
  'pages.devices.copy.pairCodeSuccess': '配對碼已複製',
  'pages.devices.device.iccid': '物理網絡卡ICCID',
  'pages.knowledgeBase.chunks.actions.add': '新增切片',
  'pages.knowledgeBase.chunks.actions.delete': '刪除',
  'pages.knowledgeBase.chunks.add.contentRequired': '請輸入切片內容',
  'pages.knowledgeBase.chunks.add.emptyHint': '當前文件尚無切片時無法追加，請先完成索引或換頁檢視',
  'pages.knowledgeBase.chunks.add.error': '新增切片失敗',
  'pages.knowledgeBase.chunks.add.modalHint': '內容將寫入當前文件在向量庫中的同一邏輯文件下，並自動完成向量化。',
  'pages.knowledgeBase.chunks.add.modalTitle': '新增切片',
  'pages.knowledgeBase.chunks.add.needAnchor': '當前頁沒有可用切片後設資料，請重新整理或從文件列表重新進入',
  'pages.knowledgeBase.chunks.add.placeholder': '輸入新切片正文…',
  'pages.knowledgeBase.chunks.add.scopeHint': '「新增切片」需從文件列表進入本頁（帶文件上下文）。在全部切片檢視下僅支援編輯與刪除。',
  'pages.knowledgeBase.chunks.add.success': '新增切片成功',
  'pages.knowledgeBase.chunks.delete.confirmDesc': '刪除後無法恢復，檢索中將不再命中該段內容。',
  'pages.knowledgeBase.chunks.delete.confirmTitle': '確定刪除該切片？',
  'pages.knowledgeBase.chunks.delete.error': '刪除切片失敗',
  'pages.knowledgeBase.chunks.delete.success': '已刪除切片',
  'pages.settings.basicInfo.newNicknameRequired': '請輸入新暱稱',
  'pages.settings.basicInfo.nicknameChangeError': '暱稱修改失敗',
  'pages.settings.basicInfo.nicknameLength': '暱稱長度為 2–20 個字元',
  'pages.settings.deleteAccount.error': '刪除賬號失敗',
  'pages.settings.fetchProfile.error': '獲取使用者資訊失敗',
  'pages.settings.password.changeError': '密碼修改失敗',
  'pages.settings.password.changeSuccess': '密碼修改成功',
  'pages.speaker.addSample': '增加樣本',
  'pages.speaker.deleteSample': '刪除樣本',
  'pages.speaker.deleteSpeaker': '刪除說話人',
  'pages.speaker.selectWavTip': '請選擇一個wav檔案',
  'pages.speaker.speakerList': '聲紋說話人列表',
  'pages.voiceClone.colExtra': '擴充套件欄位',
  'pages.voiceClone.colPath': '本地路徑',

  'menu.admin.sub-page': '二級管理頁',
  'pages.agentSetting.voiceType.groupClone': '我的克隆音色',
  'pages.agentSetting.voiceType.groupPreset': '系統預設音色',
  'pages.agentSetting.memory.longTerm.content.placeholder':
    '暫無 long_term_memory 內容，對話後會自動生成，也可點選編輯手動補充',
  'pages.agentSetting.memory.longTerm.content.editPlaceholder':
    '請輸入 long_term_memory 內容，建議保持 JSON 格式',
  'pages.agentSetting.memory.longTerm.backToForm': '返回表單編輯',
  'pages.agentSetting.memory.longTerm.switchJson': '切換到 JSON 原始碼編輯',
  'pages.admin.providerCard.voices.count': '個',
  'pages.knowledgeBase.upload.success': '上傳成功',
  'pages.knowledgeBase.upload.singleLimit': '當前版本僅支援一個文件，請先刪除現有文件',
};
